/* ═══ THEME.JS — StreetMode ═══ */

// Mega Menu
document.querySelectorAll('.has-mega').forEach(function(li) {
  var btn = li.querySelector('button, a');
  var menu = li.querySelector('.mega-menu');
  if (!menu) return;
  
  li.addEventListener('mouseenter', function() {
    document.querySelectorAll('.mega-menu.is-open').forEach(function(m) { m.classList.remove('is-open'); });
    menu.classList.add('is-open');
  });
  li.addEventListener('mouseleave', function() {
    menu.classList.remove('is-open');
  });
});

// Footer scroll top
var scrollTopBtn = document.getElementById('footer-scroll-top');
if (scrollTopBtn) {
  scrollTopBtn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
